InlineVariations = window.InlineVariations ?= {}
InlineVariations.Models ?= {}

InlineVariations.Models.Option = Backbone.Model.extend {}

module.exports = InlineVariations.Models.Option
